module.exports = __webpack_public_path__ + "img/melania.f08e7b4e.png";